<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 默认主题（浅色） */
:root {
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --text-primary: #2c3e50;
  --text-secondary: #6c757d;
  --border-color: #e9ecef;
  --hover-bg: #e9ecef;
  --selected-bg: #e3e8ec;
}

/* 深色主题 */
body.dark-mode {
  --bg-primary: #1a1a1a;
  --bg-secondary: #2d2d2d;
  --text-primary: #e1e1e1;
  --text-secondary: #a0a0a0;
  --border-color: #404040;
  --hover-bg: #363636;
  --selected-bg: #404040;
}

body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}
</style>
